import { BASE_COURSES } from '@/const/autoAddCourses'
import { GtagObject } from '@/types'

declare global {
  interface Window {
    dataLayer?: Array<Object>
  }
}

export function sendGtag(gtagObject: GtagObject) {
  const finalGtag = {
    ...gtagObject,
    event: gtagObject.event ?? 'event',
  }

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(finalGtag)
}

export const appendCourse = (originString: string, courseToAppend: string) => {
  BASE_COURSES.forEach((course) => {
    if (originString.includes(`_${course.name}`)) {
      originString = originString.replace(`_${course.name}`, '')
    }
  })

  return originString + '_' + courseToAppend
}
